import { SupportedLangs } from '../types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ExternalLang = any;

const SUPPORTED_LANGS: SupportedLangs[] = ['ru', 'en', 'kk', 'tg'];

export const transformToSupportedLanguage = (language: ExternalLang): SupportedLangs => {
  return SUPPORTED_LANGS.includes(language) ? language : SUPPORTED_LANGS[0];
};
